import { AbstractControl } from '@angular/forms';
import { IFormValidator } from '../models/form.model';

export class FormHelper {
  static getErrorMessages(formControl: AbstractControl | null, controlValidators: IFormValidator[], filter?: string[]): string[] {
    const errorMessages: string[] = [];
    for (const item in formControl?.errors) {
      if (!filter || filter.indexOf(item) > -1) {
        const validatorError = controlValidators.find((x: IFormValidator) => x.validator.getKey() === item);
        if (validatorError) {
          const message = validatorError?.errorMessage;
          if (message) {
            errorMessages.push(message);
          }
        }
      }
    }

    return errorMessages;
  }
}
